import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import Layout from '@/components/Layout';
import Home from '@/pages/Home';
import Courses from '@/pages/Courses';
import Teachers from '@/pages/Teachers';
import Enroll from '@/pages/Enroll';
import Contact from '@/pages/Contact';
import ForgotPassword from '@/pages/ForgotPassword';
import ResetPassword from '@/pages/ResetPassword';
import AdminLogin from '@/pages/admin/AdminLogin';
import AdminDashboard from '@/pages/admin/AdminDashboard';
import AdminTeachers from '@/pages/admin/AdminTeachers';
import AdminTestimonials from '@/pages/admin/AdminTestimonials';
import AdminEnrollments from '@/pages/admin/AdminEnrollments';
import AdminProfile from '@/pages/admin/AdminProfile';
import AdminQuizzes from '@/pages/admin/AdminQuizzes';
import AdminCourses from '@/pages/admin/AdminCourses';
import AdminTestSeries from '@/pages/admin/AdminTestSeries';
import AdminVideos from '@/pages/admin/AdminVideos';
import AdminHomepage from '@/pages/admin/AdminHomepage';
import ProtectedRoute from '@/components/ProtectedRoute';
import StudentLogin from '@/pages/student/StudentLogin';
import StudentRegister from '@/pages/student/StudentRegister';
import StudentDashboard from '@/pages/student/StudentDashboard';
import QuizList from '@/pages/student/QuizList';
import TakeQuiz from '@/pages/student/TakeQuiz';
import QuizResult from '@/pages/student/QuizResult';
import StudentResults from '@/pages/student/StudentResults';
import StudentTestimonial from '@/pages/student/StudentTestimonial';
import StudentProfile from '@/pages/student/StudentProfile';
import StudentProtectedRoute from '@/components/StudentProtectedRoute';
import '@/App.css';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="courses" element={<Courses />} />
            <Route path="teachers" element={<Teachers />} />
            <Route path="enroll" element={<Enroll />} />
            <Route path="contact" element={<Contact />} />
          </Route>
          
          {/* Password Reset Routes */}
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>}>
            <Route index element={<Navigate to="/admin/teachers" replace />} />
            <Route path="teachers" element={<AdminTeachers />} />
            <Route path="courses" element={<AdminCourses />} />
            <Route path="test-series" element={<AdminTestSeries />} />
            <Route path="videos" element={<AdminVideos />} />
            <Route path="quizzes" element={<AdminQuizzes />} />
            <Route path="testimonials" element={<AdminTestimonials />} />
            <Route path="enrollments" element={<AdminEnrollments />} />
            <Route path="homepage" element={<AdminHomepage />} />
            <Route path="profile" element={<AdminProfile />} />
          </Route>

          <Route path="/student/login" element={<StudentLogin />} />
          <Route path="/student/register" element={<StudentRegister />} />
          <Route path="/student" element={<StudentProtectedRoute><StudentDashboard /></StudentProtectedRoute>}>
            <Route path="dashboard" element={<QuizList />} />
            <Route path="results" element={<StudentResults />} />
            <Route path="testimonial" element={<StudentTestimonial />} />
            <Route path="profile" element={<StudentProfile />} />
          </Route>
          <Route path="/student/quiz/:quizId" element={<StudentProtectedRoute><TakeQuiz /></StudentProtectedRoute>} />
          <Route path="/student/quiz-result/:attemptId" element={<StudentProtectedRoute><QuizResult /></StudentProtectedRoute>} />
        </Routes>
        <Toaster position="top-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
